"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rozhraní pro práci s kontakty subjektu, který zatím není založen a je POUZE ověřen na základní registry - tedy máme jeho id ověření, viz {@link SubjektService#overSubjekt(Subjekt, String)}. Generated from cz.marbes.api.subjekt.v1.KontaktOvereniService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-05-22T17:56:38Z                      #

// ##############################################################

var KontaktOvereniApi = function () {
  function KontaktOvereniApi() {
    (0, _classCallCheck3.default)(this, KontaktOvereniApi);
  }

  (0, _createClass3.default)(KontaktOvereniApi, null, [{
    key: "getSubjektKontakty",

    /**
     * Načtení všech kontaktů daného subjektu, případně pouze těch, které odpovídají předaným typům.
     *
     * @param overeniId id ověření subjektu
     * @param typyKontaktu seznam požadovaných typů, pokud je prázdný nebo null, vrací se všechny typy
     * @return seznam kontaktů nebo prázdný seznam
     */
    value: function getSubjektKontakty(overeniId, typyKontaktu) {
      var uri = serverContextPath + ("/api/subjekt/v1/subjekty/overeni/" + overeniId + "/kontakt");
      var headers = undefined;
      var params = { typyKontaktu: typyKontaktu };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return KontaktOvereniApi;
}();

exports.default = KontaktOvereniApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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